import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/public/assets/images/hero/SocBanner.webp");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/src/components/container/container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Counter"] */ "/var/www/SOC/src/components/counter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionHeading"] */ "/var/www/SOC/src/components/section-heading/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoPlayer"] */ "/var/www/SOC/src/components/video-player/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AboutSection"] */ "/var/www/SOC/src/sections/about/v1/index.tsx");
